{
  "Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူး",
  "Reset settings": "ဆက်တင်များကို ပြန်လည်သတ်မှတ်ပါ",
  "Close": "ပိတ်ပါ",
  "Content Adjustments": "အကြောင်းအရာ ချိန်ညှိမှုများ",
  "Adjust Font Size": "ဖောင့်အရွယ်အစားကို ချိန်ညှိပါ",
  "Highlight Title": "ခေါင်းစဉ်ကို အထူးပြုပါ",
  "Highlight Links": "လင့်များကို အထူးပြုပါ",
  "Readable Font": "ဖတ်ရန်လွယ်ကူသော ဖောင့်",
  "Color Adjustments": "အရောင် ချိန်ညှိမှုများ",
  "Dark Contrast": "မှောင်မိုက်သော ကွာခြားမှု",
  "Light Contrast": "အလင်းရောင် ကွာခြားမှု",
  "High Contrast": "မြင့်မားသော ကွာခြားမှု",
  "High Saturation": "မြင့်မားသော အရောင်စွဲမှု",
  "Low Saturation": "နိမ့်သော အရောင်စွဲမှု",
  "Monochrome": "တစ်ရောင်တည်း",
  "Contrast": "ကွဲပြားမှု",
  "Invert Colors": "အရောင်များ ပြန်လှန်ပါ",
  "Tools": "ကိရိယာများ",
  "Reading Guide": "ဖတ်ရှုရန် လမ်းညွှန်",
  "Stop Animations": "အန်နီမေးရှင်းများကို ရပ်ပါ",
  "Big Cursor": "ကြီးမားသော ကာဆာ",
  "Increase Font Size": "ဖောင့်အရွယ်အစားကို တိုးချဲ့ပါ",
  "Decrease Font Size": "ဖောင့်အရွယ်အစားကို လျှော့ချပါ",
  "Letter Spacing": "အက္ခရာအကြား အကွာအဝေး",
  "Line Height": "စာကြောင်းအမြင့်",
  "Font Weight": "ဖောင့်အလေးချိန်",
  "Dyslexia Font": "Dyslexia ဖောင့်",
  "Language": "ဘာသာစကား",
  "Open Accessibility Menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူးကို ဖွင့်ပါ",
  "Widget Settings": "ဝစ်ဂျက် ဆက်တင်များ",
  "Widget Position": "ဝစ်ဂျက် တည်နေရာ",
  "Top Left": "အပေါ် ဘယ်ဖက်",
  "Top Center": "အပေါ် အလယ်",
  "Top Right": "အပေါ် ညာဖက်",
  "Center Left": "အလယ် ဘယ်ဖက်",
  "Center Right": "အလယ် ညာဖက်",
  "Bottom Left": "အောက် ဘယ်ဖက်",
  "Bottom Center": "အောက် အလယ်",
  "Bottom Right": "အောက် ညာဖက်",
  "Screen Reader": "ဖန်သားပြင် ဖတ်စက်",
  "Voice Navigation": "အသံ လမ်းညွှန်",
  "Custom Color": "စိတ်ကြိုက် အရောင်",
  "Change the site's colors": "ဆိုက်အရောင်များ ပြောင်းပါ",
  "Backgrounds": "နောက်ခံများ",
  "Headings": "ခေါင်းစဉ်များ",
  "Contents": "အကြောင်းအရာများ",
  "Reset colors": "အရောင်များ ပြန်ချိန်ပါ",
  "Image Desaturation": "ပုံအရောင် လျော့ချခြင်း",
  "Search languages": "ဘာသာစကားများ ရှာဖွေပါ",
  "No languages found": "ဘာသာစကား မတွေ့ပါ",
  "Accessibility Profiles": "ဝင်ရောက်ရလွယ်သောပရိုဖိုင်များ",
  "Motor Impaired": "လှုပ်ရှားရေးအကန့်အသတ်",
  "Big cursor, voice navigation, and no animations.": "ကြီးတဲ့ ကာဆာ၊ အသံဖြင့် ခရီးညွှန်ခြင်း၊ အန်နီမေးရှင်း မရှိ။",
  "Blind": "မြင်သာမှုတားဆီး",
  "Screen reader helpers with higher contrast.": "ထင်ရှားတဲ့ ကွန်ထရပ်ဖြင့် စကရင်ဖတ်သူ ကူညီမှုများ။",
  "Color Blind": "အရောင်မြင်ကွဲခြား",
  "High contrast palette with desaturated media.": "ထင်ရှားတဲ့ ကွန်ထရပ် ပဲလက်နှင့် အရောင်ချည်း ကူးထားသော မီဒီယာ။",
  "Dyslexia": "စာဖတ်ရှုပ်ထွေးခြင်း",
  "Friendly font, extra spacing, stronger weight.": "ဖတ်ရလွယ်သော ဖောင့်၊ ထပ်ဆောင်း ကွာဟချက်နှင့် အထူပို။",
  "Low vision": "အမြင်နည်းခြင်း",
  "Dark contrast and 130% magnification.": "မှောင်မိုက်သော ကွန်ထရပ်နှင့် ၁၃၀% ထပ်တိုးကြည့်ရှု။",
  "Cognitive & Learning": "ထင်ရှားမြင်သာ & ပညာသင်ယူ",
  "Highlights key sections and enables voice help.": "အဓိကအပိုင်းများကို အလင်းပေးပြီး အသံအကူအညီကို ဖွင့်ပေးပါသည်။",
  "Seizure & Epileptic": "Fits & မျိုးရိုးစားရောဂါ",
  "Stops animations and desaturates imagery.": "အန်နီမေးရှင်းကို ရပ်တန့်ပြီး ပုံရိပ်အရောင်ညှိသည်။",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "ဖတ်ရှုမှုလမ်းညွှန်၊ အရောင်ထိမ်းလင်းထားသော လင့်များနှင့် သက်သာသော အရောင်။",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
